import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import { convertToBase64, convertfromBase64, formatDocumentUploadBase64StringByDocumentType } from "../../common/utils";
import {
  setLoading,
  setLoadingFalse,
} from "../unifiedQuestions/unifiedQuestionSlice";
import { GetDocStoreDetails } from "../ordersSummary/orderSummarySlice";
import { GetAllRequiredDocument } from "../requiredDocument/requiredDocumentSlice";
// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  DocStoreIDs: [],
  DocumentTypes: [],
  MergeSuccess: false,
};

// our slice
const uploadDocumentSlice = createSlice({
  name: "uploadDocument",
  initialState,
  reducers: {
    setLoadingState: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setDocumentType: (state, { payload }) => {
      state.DocumentTypes = payload;
    },
    setMergeSuccess: (state, { payload }) => {
      state.MergeSuccess = payload;
    },
  },
});

// export the actions
export const {
  setLoadingState,
  setError,
  setSuccess,
  setMergeSuccess,
  setDocumentType,
} = uploadDocumentSlice.actions;

export const uploadDocumentSelector = (state) => state.uploadDocument;

// export the default reducer
export default uploadDocumentSlice.reducer;

export const UploadDocumentExpress =
  (request, indexes, name, fieldName, { setValue, trigger, field }) =>
    async (dispatch) => {
      try {
        dispatch(setLoading());
        let data = { UserID: request.UserID, RequestObject: request };
        const results = await http
          .post("Document/UploadDocumentExpress", data)
          .then((result) => {
            return result;
          });

        if (results.data.responseCode == 0) {
          const fileArray = [
            { name, storageFileID: results.data.responseObject.storageFileID },
          ];
          setValue(
            fieldName,
            field.value ? [...field.value, ...fileArray] : fileArray
          );
          trigger(fieldName);
          field.onChange(
            field.value ? [...field.value, ...fileArray] : fileArray
          );
          // let result = {
          //   DocStoreID: results.data.responseObject.storageFileID,
          //   FileName: name,
          //   Indexes: indexes,
          // };
          // dispatch(setDocumentUploadDocStoreID(result));
        }
        dispatch(setLoadingFalse());
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.message
            : error.message;
        dispatch(setError(errorMessage));
        dispatch(setLoadingFalse());
      }
    };

export const ReadDocumentAsStream =
  (storageFileID, UserID, DocStoreID) => async (dispatch) => {
    try {
      dispatch(setLoadingState());
      let request = {
        DocumentID: storageFileID,
        DocStoreId: DocStoreID
      };

      let data = { UserID: UserID, RequestObject: request };
      const results = await http
        .post("Document/ReadDocumentAsStream", data)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setSuccess());
        convertfromBase64(results.data.responseObject.documentStream, results.data.responseObject.fileName);
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const DeleteDocumentExpress =
  (DocStoreID, UserID) => async (dispatch) => {
    try {
      dispatch(setLoadingState());
      let request = {
        DocumentID: DocStoreID,
      };
      let data = { UserID: UserID, RequestObject: request };
      const results = await http
        .post("Document/DeleteDocumentExpress", data)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setSuccess());
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const GetDocumentType = (FileID, UserID) => async (dispatch) => {
  try {
    dispatch(setLoadingState());
    let request = {
      FileID: FileID,
    };

    let data = { UserID: UserID, RequestObject: request };
    const results = await http
      .post("Document/GetDocumentType", data)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
      dispatch(setDocumentType(results.data.responseObject.documentTypes));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetAdditionalUploadedDocs =
  (FileID, UserID, fieldName, { setValue }) =>
    async (dispatch) => {
      try {
        dispatch(setLoadingState());
        let request = {
          fileID: FileID,
        };

        let data = { UserID: UserID, RequestObject: request };
        const results = await http
          .post("Order/GetSavedAdditionalUploadedDocs", data)
          .then((result) => {
            return result;
          });

        if (results.data.responseCode == 0) {
          dispatch(setSuccess());
          setValue(fieldName, results?.data?.responseObject?.additionalDocs);
        }
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.message
            : error.message;
        dispatch(setError(errorMessage));
      }
    };

export const uploadFileToMemory =
  (
    file,
    name,
    fieldName,
    propertyDependent,
    { setValue, trigger, field },
    isSingleDoc
  ) =>
    async (dispatch) => {
      try {
        dispatch(setLoadingState());
        let Base64String = await convertToBase64(file);
        Base64String = formatDocumentUploadBase64StringByDocumentType(file?.type, Base64String)
        const fileArray = [];
        fileArray?.push({
          name,
          storageFileID: 0,
          Base64String: Base64String,
        });
        isSingleDoc
          ? setValue(fieldName, [])
          : setValue(
            fieldName,
            field.value && propertyDependent
              ? [...field.value, ...fileArray]
              : fileArray
          );
        trigger(fieldName);
        isSingleDoc
          ? field.onChange([])
          : field.onChange(
            field.value && propertyDependent
              ? [...field.value, ...fileArray]
              : fileArray
          );

        dispatch(setLoadingFalse());
        dispatch(setSuccess());
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.message
            : error.message;
        dispatch(setError(errorMessage));
      }
    };

export const uploadFiles =
  (
    request,
    name,
    fieldName,
    files,
    { setValue, trigger, field },
    isSingleDoc
  ) =>
    async (dispatch) => {
      dispatch(setLoadingState());
      const fileArray = [];
      for (let file of files) {
        if (!file?.Base64String) {
          let Base64String = await convertToBase64(file);
          Base64String = formatDocumentUploadBase64StringByDocumentType(file?.type, Base64String)
          request.DocumentRawStream = Base64String;
        } else {
          request.DocumentRawStream = file?.Base64String;
        }
        await uploadFile(request, name, fieldName, file, fileArray, {
          setValue,
          trigger,
          field,
          dispatch,
        });
      }
      isSingleDoc
        ? setValue(fieldName, [])
        : setValue(
          fieldName,
          field.value && !isSingleDoc
            ? [...field.value, ...fileArray]
            : fileArray
        );
      trigger(fieldName);
      isSingleDoc
        ? field.onChange([])
        : field.onChange(
          field.value && !isSingleDoc
            ? [...field.value, ...fileArray]
            : fileArray
        );
      dispatch(setLoadingFalse());
      dispatch(setSuccess());
      dispatch(GetAllRequiredDocument(request?.FileID, request?.UserID));
      dispatch(GetDocStoreDetails(request?.FileID, request?.UserID));
      dispatch(
        GetAdditionalUploadedDocs(
          request?.FileID,
          request?.UserID,
          "additionalDocumentsArray",
          { setValue }
        )
      );
    };

const uploadFile = (
  request,
  name,
  fieldName,
  file,
  fileArray,
  { setValue, trigger, field, dispatch }
) => {
  return new Promise(async (resolve, reject) => {
    try {
      dispatch(setLoadingState());
      let data = { UserID: request.UserID, RequestObject: request };
      const results = await http
        .post("Document/UploadDocumentExpress", data)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        // fileArray.push({
        //   name,
        //   storageFileID: results.data.responseObject.storageFileID,
        // });
        dispatch(setSuccess())
      }
      resolve();
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
      reject(error);
    }
  });
};

export const SendEmailExpress =
  (req, { toast }) =>
    async (dispatch) => {
      try {
        dispatch(setLoadingState());
        let data = { UserID: req.UserID, RequestObject: req };
        const results = await http
          .post("Document/SendEmailExpress", data)
          .then((result) => {
            return result;
          });

        if (results.data.responseObject.isSuccess) {
          dispatch(setSuccess());
          toast("Email sent successfully!", { type: "success" });
        }
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.message
            : error.message;
        dispatch(setError(errorMessage));
      }
    };

export const SendEmailForSendPolicyDocumentExpress =
  (req, { toast }) =>
    async (dispatch) => {
      try {
        dispatch(setLoadingState());
        let data = { UserID: req.UserID, RequestObject: req };
        const results = await http
          .post("Document/SendEmailForSendPolicyDocumentExpress", data)
          .then((result) => {
            return result;
          });

        if (results.data.responseObject.isSuccess) {
          dispatch(setSuccess());
          toast("Email sent successfully!", { type: "success" });
        }
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.message
            : error.message;
        dispatch(setError(errorMessage));
      }
    };

export const MergeDocumentExpress = (req) => async (dispatch) => {
  try {
    dispatch(setLoadingState());
    dispatch(setMergeSuccess(false));
    let data = { UserID: req.UserID, RequestObject: req };
    const results = await http
      .post("Document/MergeDocumentExpress", data)
      .then((result) => {
        return result;
      });

    if (results.data.responseObject.isSuccess) {
      dispatch(setSuccess());
      dispatch(setMergeSuccess(results.data.responseObject.isSuccess));
      dispatch(GetDocStoreDetails(req.FileID, req.UserID));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
